import { useContext } from "react";
import { LocationContext } from "context/Location";
import { useAuth } from "hooks/useAuth";

/**
 * useClinicRejected — true when the signed-in facility owner's clinic was
 * declined by an admin (locations.status === "rejected"). The clinic never goes
 * live on the patient map, and the owner can't change the decision themselves,
 * so a persistent banner tells them it was rejected and points them to support.
 *
 * Mirrors useClinicPending; both feed the same bottom-pinned status banner
 * (StatusBanner) and the layout space it reserves (DashboardNav,
 * FacilityChecklist), so they can't drift apart.
 */
export const useClinicRejected = () => {
  const { userData } = useAuth();
  const { location } = useContext(LocationContext);
  return userData?.role === "facility" && location?.status === "rejected";
};
